/**
 *
 * app reducer
 *
 */

import { CLIENT_SIDE_READY } from './app-constants';

const initialState = {
    clientSideReady: false,
};

const appReducer = (state = initialState, action) => {

    switch (action.type) {

        case CLIENT_SIDE_READY:
            return {
                ...state,
                clientSideReady: true,
            };
        default:
            return state;

    }

};

export default appReducer;
